<template>
    <v-data-table
        hide-default-footer
        :headers="headers"
        :items="items"
        disable-pagination
        :sort-by.sync="columnName"
        :sort-desc.sync="isDescending"
    >
<!--     <template v-slot:header="{ props }">
        <th id="tableHeader" v-for="head in props.headers" :key="head">{{ head.text}}</th>
    </template> -->

    <template v-slot:item.fileName="{ item }">
        <a @click="$emit('rowClicked', item)">
          {{ item.fileName }}
        </a>
    </template>

    <template v-slot:item.creationDate="{ item }">
        <span class="date">{{ new Date(item.creationDate).toLocaleString('de-DE', { day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
    </template>

    <template v-slot:item.surveys="{ item }">
        <div class="pl-5">
          <v-chip id="chip" :color="item.surveys.length == 0 ? 'primary_light' : 'primary'">{{item.surveys.length}}</v-chip>
          <v-icon v-if="item.surveys.length > 0" color="secondary" @click="$emit('viewSurvey', item)">mdi-open-in-new</v-icon>
        </div>
    </template>
      <template v-slot:item.actions="{ item }">
      <v-icon color="gray" @click="$emit('rowClicked', item)" class="mr-2">mdi-pencil</v-icon>
      <v-icon color="gray" @click="$emit('deleteModel', item)">mdi-delete</v-icon>
    </template>
    </v-data-table>
</template>
<script>
export default {
    props:{
        headers:{
            type: Array
        },
        items:{
            type: Array
        }
    },
    data(){
        return {
            search: '',
            columnName: 'creationDate',
            isDescending: true,
        }
    }
}
</script>
<style>
/*.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th{*/
/*    padding: 16px;*/
/*    color: gray;*/
/*    font-size: 0.75rem;*/
/*    font-weight: 500;*/
/*}*/
/*tbody tr{*/
/*   background-color: rgba(0, 0, 0, .05);*/
/*   margin: 0px 10px !important;*/
/* }*/
table {
  border-spacing: 0 1rem !important;
}
.primary_light::before {
  opacity: .14 !important;
  background-color: var(--v-primary-base) !important;
}
.primary_light {
  color: var(--v-primary-base) !important;
  background-color: unset !important;
}
th:first-child {
  padding-left: 1.8rem;
}
td:first-child {
  /*padding-left: 1.8rem;*/
}
</style>